module.exports = __webpack_public_path__ + "static/media/mausam - cold day.89db5274.png";